import styled from 'styled-components/native'

export const OptionsContainer = styled.View`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 25px;
    margin-bottom: 25px;
`
